var _path, _path2, _path3, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIco6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F0F0F0"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256,0C154.506,0,66.81,59.065,25.402,144.696h461.195C445.19,59.065,357.493,0,256,0z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#496E2D"
    },
    d: "M256,512c-101.494,0-189.19-59.065-230.598-144.696h461.195C445.19,452.935,357.493,512,256,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2001D"
    },
    d: "M499.911,178.087H12.089C4.247,202.656,0,228.831,0,256s4.247,53.344,12.089,77.913H499.91 C507.753,309.344,512,283.169,512,256S507.753,202.656,499.911,178.087z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "335.715,118.301 305.398,104.308 256,216.159 206.602,104.308 176.285,118.301 237.613,256  176.285,393.699 206.602,407.692 256,295.841 305.398,407.692 335.715,393.699 274.387,256  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M276.591,131.489C264.855,118.672,256,111.304,256,111.304s-8.855,7.367-20.591,20.185v249.02 C247.145,393.328,256,400.696,256,400.696s8.855-7.367,20.591-20.186V131.489z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2001D"
    },
    d: "M200.348,179.243v153.512c12.402,21.975,27.581,39.987,38.957,51.929V127.315 C227.929,139.256,212.749,157.269,200.348,179.243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2001D"
    },
    d: "M311.652,179.243c-12.403-21.975-27.581-39.987-38.957-51.928v257.369 c11.375-11.942,26.554-29.954,38.957-51.929V179.243z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M311.652,179.243v153.512c12.555-22.249,22.261-48.558,22.261-76.755S324.207,201.493,311.652,179.243z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M200.348,179.243v153.512c-12.555-22.249-22.261-48.558-22.261-76.755S187.793,201.493,200.348,179.243z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco6);
export default __webpack_public_path__ + "static/media/ico6.96e32813b3840bcd19c04b7d5e400615.svg";
export { ForwardRef as ReactComponent };